export default {
  toast: {
    open: false,
    message: '',
    type: '',
  },
};
